<template>
    <v-dialog
        v-if="template != null"
        v-model="dialog"
        max-width="1000"
        scrollable
    >
        <bulk-creation-inputs
            ref="bulk_creation_inputs"
            :title="template.label"
            ok-text="Create New Bulk Message Based On This Template"
            :bulk_message_label="bulk_message_label"
            :bulk_message_category="bulk_message_category"
            :bulk_message_filter="bulk_message_filter"
            @update:bulk_message_category="bulk_message_category = $event"
            @update:bulk_message_filter="bulk_message_filter = $event"
            @update:bulk_message_label="bulk_message_label = $event"
            @ok="onOk"
            @cancel="dialog = false"
        >
            <template #before-inputs>
                <div
                    class="template-preview shaded mb-4 pa-4"
                    v-html="$rc.wrapHTML(template.message_patterns[0])"
                />
            </template>
        </bulk-creation-inputs>
    </v-dialog>
</template>

<script>
import BulkCreationInputs from "../bulk-creation-inputs.vue";

export default {
    components: {
        BulkCreationInputs,
    },

    data() {
        return {
            template: null,
            template_bulk_message: null,
            dialog: false,

            bulk_message_label: '',
            bulk_message_category: '',
            bulk_message_filter: '',
        }
    },

    methods: {
        showDialog(template, type) {
            this.template = template;

            let month = new Date().toLocaleString('default', { month: 'long' });
            let year = new Date().getFullYear();

            if (type === 'wine-double-opt-in') {
                this.bulk_message_category = template.consent_category || '';
            } else {
                this.bulk_message_category = '';
            }
            this.bulk_message_filter = '';
            this.bulk_message_label = month + ' ' + year + ': ' + template.label;
            this.dialog = true;
        },

        onOk() {
            this.dialog = false;

            this.$rc.rest({
                spinner: true,
                endpoint: 'POST: /api/v1/bulk/templates/create-bulk-message-from-template-v3',

                params: {
                    template_id: this.template.template_id,
                    organization_id: this.$rc.$state.organization_id,
                    label: this.bulk_message_label,
                    category: this.bulk_message_category,
                    filter_type_on_send_to_recipients_when: this.bulk_message_filter,
                    use_legacy_variables: false,
                    is_preview: false
                },

                on_success: (data) => {
                    this.$router.push({
                        name: 'view-bulk-message',
                        params: {
                            bulk_message_id: data.bulk_message_id
                        }
                    });
                },

                on_error: 'Unable to create new bulk message based on template',
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.template-preview {
    border-radius: var(--border-radius-default);
    max-height: 500px;
    overflow-y: auto;
}
</style>
